import { Badge } from 'reactstrap';
import styled, { css } from 'styled-components';

function getBadgeStatus(status) {
  if (status === 'pending') {
    return '#018ccc !important';
  }

  if (status === 'doing') {
    return '#0ccab4 !important';
  }

  if (status === 'finished') {
    return '#7a7a7a !important';
  }

  if (status === 'canceled') {
    return '#fe1933 !important';
  }

  return false;
}

export const Container = styled.div`
  height: auto;
  background: #fff;
  position: relative;
  grid-row: span auto;
  filter: drop-shadow(0px 3px 3px #d9d9d9);
  border-radius: 8px;
  flex-direction: column;
  justify-content: space-between;
  display: flex;
`;

export const CustomBadge = styled(Badge)`
  line-height: 16px;
  background-color: ${(props) => getBadgeStatus(props.status)};
  color: #fff;
`;

export const Orders = styled.div`
  background: #fff;
  border-radius: 0 0 8px 8px;
`;

export const Header = styled.div`
  background: #ededed;
  height: 72px;
  display: flex;
  flex-direction: column;
  padding: 6px;
  border-radius: 8px 8px 0 0;

  ${(props) =>
    props.status === 'pending' &&
    css`
      border-top: 2px solid #018ccc;
    `}

  ${(props) =>
    props.status === 'doing' &&
    css`
      border-top: 2px solid #0ccab4;
    `}

  ${(props) =>
    props.status === 'canceled' &&
    css`
      border-top: 2px solid #fe1933;
    `}

  ${(props) =>
    props.status === 'alter' &&
    css`
      border-top: 2px solid #ccbbed;
    `}
`;

export const BuyerInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
  background: #ededed;

  ${(props) =>
    props.isProductLate &&
    css`
      background: #ffa814;
    `}
`;

export const OrdersInfo = styled.main`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
  border-bottom: 1px solid #d9d9d9;
`;

export const Main = styled.main``;

export const Footer = styled.footer`
  width: 100%;
  border-radius: 0 0 8px 8px;
  padding: 10px;
  display: flex;
  gap: 8px;
`;

export const ConfirmButton = styled.button`
  width: 100%;
  height: 48px;
  background: #018ccc;
  border-radius: 8px;
  border: none;
  color: #fff;
  font-size: 18px;
  font-weight: bold;

  &:disabled {
    background: #d9d9d9;
    pointer-events: none;
    cursor: not-allowed;
  }

  ${(props) =>
    props.status === 'doing' &&
    css`
      background: #0ccab4;
    `}

  ${(props) =>
    props.status === 'canceled' &&
    css`
      background: #fe1933;
    `}

  ${(props) =>
    props.status === 'alter' &&
    css`
      background: #ccbbed;
    `}
`;

export const ExpandButton = styled.button`
  width: 100%;
  height: 40px;
  background: #f4f4f4;
  position: absolute;
  bottom: 48px;
  border-radius: 0px 0px 5px 5px;
  border: none;
  color: #3d3d3d;
  font-size: 14px;
  font-weight: bold;
`;

export const IfoodTurboBadge = styled.span`
  display: inline-flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 12px;
  background: #EFAFB3;
  margin-left: 8px;

  span {
    color: var(--Takeat-Colors-Neutrals-Grey-01, #545454);
    text-align: right;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.1px;
  }
`